import {
  SEARCH_INDICADORES_CHANGED,
  SEARCH_INDICADORES_LOGOUT,
} from "../../const/actionsType";
import { dates } from "investira.sdk";

const INITIAL_STATE = {
  pesquisa: "",
  result: {},
  pages: {},
  updatedAt: dates.toDate(),
};

function searchIndicadoresReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SEARCH_INDICADORES_CHANGED:
      return {
        ...state,
        ...action.payload,
      };
    case SEARCH_INDICADORES_LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default searchIndicadoresReducer;
